import { NewActivity } from 'types';
import { User } from 'types/interfaces/user/User';

import { httpClient } from './httpClient';

export enum NotificationActionTypes {
  OpenSenderThread = 'open_sender_thread',
  OpenContactUs = 'open_contact_us',
  OpenVideosPage = 'open_videos_page',
  None = 'null',
}

export type NotificationImageType =
  | 'sender'
  | 'system_success'
  | 'system_error'
  | 'system_warning';

export type SystemNotification = {
  sender?: User;
  image_type: NotificationImageType;
  action_type: NotificationActionTypes;
  title: string;
  description: string;
  is_new: boolean;
  created_at: string;
};

export interface NotificationsResponse {
  visits: NewActivity;
  likes: NewActivity;
  matches: NewActivity;
  notifications: SystemNotification[];
}

export const NotificationsApi = {
  async fetchNotifications() {
    const { data } = await httpClient.get<NotificationsResponse>(
      '/notifications'
    );

    return data;
  },
};
